
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './local';

const savedLanguage = localStorage.getItem('preferredLanguage') || 'en';

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'en',
  supportedLngs: ['en', 'it', 'de', 'fr', 'zh', 'he', 'ar', 'ru', 'es'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
